<template>
  <b-row class="mt-4 mb-4">
    <b-col cols="1" class="spark-desktop-spacer"></b-col>
    <b-col
      cols="11"
      sm="10"
      md="10"
      lg="10"
      xl="10"
      class="p-4 m-4 bg-danger spark-variant-text-light border-dark rounded "
    >
      <b-row>
        <b-col cols="2">
          <i
            class="fas fa-exclamation-triangle paragraph_warning spark-variant-text-light"
          ></i>
        </b-col>
        <b-col cols="8" class="text-center">
          <div v-html="label" class="font-weight-bold  h3 pt-4"></div>
          <div v-html="sub_label" class="h6 pt-2" v-if="sub_label"></div>
        </b-col>
        <b-col cols="2" class="text-right">
          <i
            class="fas fa-exclamation-triangle paragraph_warning spark-variant-text-light"
          ></i>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="1" class="spark-desktop-spacer"></b-col>
  </b-row>
</template>

<script>
export default {
  name: "spark-warning",
  props: {
    label: {
      type: String,
      required: true
    },
    sub_label: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      value: ""
    };
  },
  computed: {
    Value() {
      return this.value;
    }
  }
};
</script>
